import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 5 * 60 * 1000, retry: 1, refetchOnWindowFocus: false } },
});

let generation = 0;
export const authGeneration = () => generation;

export function resetAuthSession() {
  generation++;
  queryClient.clear();
  // Retire responses stored by the previous service worker.
  if (typeof caches !== "undefined") void caches.delete("api-cache").catch(() => {});
  return generation;
}
